<template>
    <div class="page-code-add-info">
        <el-form ref="form" :rules="rules" :model="form" label-width="145px" class="form-box">
            <el-form-item label="代码位名称" prop="adslot_name">
                <el-input v-model="form.adslot_name" show-word-limit :maxlength="30" clearable/>
            </el-form-item>
            
            <el-form-item label="所属应用" prop="media_id">
                <el-select
                    v-model="form.media_id"
                    placeholder="请选择"
                    clearable
                    filterable
                    :disabled="!!id"
                    @change="getStyleList"
                >
                    <el-option
                        v-for="item in appOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="渲染方式" prop="render_method">
                <el-radio-group
                    v-model="form.render_method"
                    :disabled="!!id"
                    @change="handleRenderMethodChange"
                >
                    <el-radio-button
                        v-for="item in renderMethodOptions"
                        :key="item.value"
                        :label="item.value"
                    >{{ item.label }}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            
            <el-form-item label="创意类型" prop="acc_adtype" v-if="is_acc_adtype">
                <el-radio-group
                    v-model="form.acc_adtype"
                    @change="handleAccAdtypeChange"
                >
                    <el-radio-button
                        v-for="item in accAdtypesOptions"
                        :key="item.value"
                        :label="item.value"
                        @change="getStyleList"
                    >
                        {{ item.label }}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            
            <el-form-item label="创意类型" prop="adslot_acc_adtypeArr" v-if="+form.render_method === 2">
                <el-checkbox-group v-model="form.adslot_acc_adtypeArr">
                    <template v-for="item in styleCustomOptions">
                        <el-checkbox
                            v-if="+form.acc_adtype !== item.hidden"
                            :key="String(item.value)"
                            :label="String(item.value)"
                            class="image-radio-item"
                        >
                            <el-image
                                class="image-radio-i"
                                :src="item.image"
                                fit="fill"
                            />
                        </el-checkbox>
                    </template>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="创意样式" prop="creative_type_id" v-else>
                <el-radio-group v-if="form.media_id" v-model="form.creative_type_id">
                    <el-radio
                        v-for="item in styleOptions"
                        :key="item.style_code"
                        :label="item.style_code"
                        class="radio-image-style"
                    >
                        <div class="style-card">
                            <div class="image-container">
                                <el-image :src="item.style_preview_url" fit="contain" :preview-src-list="[item.style_preview_url]" />
                            </div>
                            <div class="style-text">{{ item.style_text }}</div>
                        </div>
                    </el-radio>
                </el-radio-group>
                <span v-else>请先选择所属应用</span>
            </el-form-item>
            
            <template v-if="+form.acc_adtype !== 2">
                <el-form-item label="视频声音" prop="video_sound" v-if="is_video">
                    <el-radio-group v-model="form.video_sound">
                        <el-radio-button
                            v-for="item in videoSoundOptions"
                            :key="item.value"
                            :label="item.value"
                        >{{ item.label }}
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>
                
                <el-form-item label="视频自动播放" prop="video_auto_play" v-if="is_video">
                    <el-radio-group v-model="form.video_auto_play">
                        <el-radio-button
                            v-for="item in videoAutoPlayOptions"
                            :key="item.value"
                            :label="item.value"
                        >{{ item.label }}
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </template>
            
            <!--交互样式摇一摇-->
            <template v-if="!['HarmonyOS'].includes(platform)">
                <el-form-item prop="shake_num_switch">
                    <div slot="label" style="display: inline-block;">
                        交互样式摇一摇
                        <el-popover
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            content="安卓3.474及以上版本支持"
                            v-if="platform === 'android'"
                        >
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </div>
                    <el-radio-group v-model="form.shake_num_switch">
                        <el-radio-button
                            v-for="item in shakeSwitchOptions"
                            :key="item.value"
                            :label="item.value"
                        >
                            {{ item.name }}
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="shake_num" v-if="platform === 'android' && form.shake_num_switch === 1" style="margin-top: 20px; margin-bottom: 0;">
                    <template v-if="form.render_method === 1">
                        <el-radio-group v-model="form.shake_num">
                            <el-radio
                                v-for="item in shakeOptionsTemplateRender"
                                :key="item.style_code"
                                :label="item.style_code"
                                class="radio-image-style"
                            >
                                <div class="style-card">
                                    <div class="image-container">
                                        <el-image :src="item.style_preview_url" fit="contain" :preview-src-list="[item.style_preview_url]" />
                                    </div>
                                    <div class="style-text">{{ item.style_text }}</div>
                                </div>
                            </el-radio>
                        </el-radio-group>
                    </template>
                    <template v-if="form.render_method === 2">
                        <el-radio-group v-model="form.shake_num">
                            <el-radio
                                v-for="item in shakeOptions"
                                :key="item.style_code"
                                :label="item.style_code"
                                class="radio-image-style"
                            >
                                <div class="style-card">
                                    <div class="image-container">
                                        <el-image :src="item.style_preview_url" fit="contain" :preview-src-list="[item.style_preview_url]" />
                                    </div>
                                    <div class="style-text">{{ item.style_text }}</div>
                                </div>
                            </el-radio>
                        </el-radio-group>
                    </template>
                </el-form-item>
                <div class="yyy_tips_wrap" v-if="form.render_method === 2">
                    <div class="yyy_tips">
                        <span class="f_red">提示：</span>需要支持"摇一摇"交互展示后才能配置该功能，否则用户未看到"摇一摇"相关提示时摇动手机后也会触发广告点击和跳转，不符合监管合规要求。
                        <div style="text-indent: 37px;">如您未按照监管合规要求执行，由此导致的不利后果由您自行承担。</div>
                    </div>
                </div>
            </template>
            
            <el-form-item label="竞价类型" prop="bidding_type">
                <el-radio-group
                    v-model="form.bidding_type"
                    :disabled="!!id"
                    @change="handleBiddingTypeChange"
                >
                    <el-radio-button
                        v-for="item in biddingTypeOptions"
                        :key="item.value"
                        :label="item.value"
                    >
                        {{ item.label }}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="CPM价格" prop="bid_cpm" v-if="+form.bidding_type === 2">
                <el-input v-model="form.bid_cpm" :disabled="!!id">
                    <span class="unit-text" slot="suffix">元</span>
                </el-input>
            </el-form-item>
            
            <el-form-item>
                <el-button @click="onCancel">取消</el-button>
                <el-button type="primary" @click="onSubmit">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import {getCodeDetail, getAllAppList, getStyleList, doAddCode, doEditCode} from '@/apis/flow.js';
import {
    RenderMethod,
    RenderEnum,
    AccAdtypes,
    StyleCustoms,
    BiddingTypes,
    BiddingTypes2,
    VideoSound,
    VideoAutoPlay
} from '@/common/constant'

export default {
    props: {
        codeType: {
            default: ''
        },
    },
    
    data() {
        return {
            appOptionsMap: {},
            appOptions: [],
            renderMethodOptions: [
                ...RenderMethod
            ],
            accAdtypesOptions: [
                ...AccAdtypes
            ],
            biddingTypeOptions: [],
            styleOptions: [],
            styleCustomOptions: [
                ...StyleCustoms
            ],
            videoSoundOptions: [
                ...VideoSound
            ],
            videoAutoPlayOptions: [
                ...VideoAutoPlay
            ],
            shakeSwitchOptions: [
                {name: '开启', value: 1},
                {name: '关闭', value: 2},
            ],
            
            // 模版渲染
            shakeOptionsTemplateRender: [
                {
                    style_code: '127932',
                    style_text: '居中',
                    style_preview_url: 'https://cdn-qukan.1sapp.com/qukan/png/yaoyiyao4.png'
                }
            ],
            
            // 自渲染
            shakeOptions: [
                {
                    style_code: '127933',
                    style_text: '左上',
                    style_preview_url: 'https://cdn-qukan.1sapp.com/qukan/png/yaoyiyao1.png'
                },
                {
                    style_code: '127932',
                    style_text: '左下',
                    style_preview_url: 'https://cdn-qukan.1sapp.com/qukan/png/yaoyiyao2.png'
                },
                {
                    style_code: '127934',
                    style_text: '右下',
                    style_preview_url: 'https://cdn-qukan.1sapp.com/qukan/png/yaoyiyao3.png'
                },
                {
                    style_code: '127935',
                    style_text: '居中',
                    style_preview_url: 'https://cdn-qukan.1sapp.com/qukan/png/yaoyiyao4.png'
                }
            ],
            rules: {
                adslot_name: [
                    {required: true, message: '代码位名称必填'}
                ],
                media_id: [
                    {required: true, message: '所属应用必选'}
                ],
                render_method: [
                    {required: true, message: '渲染方式必选'}
                ],
                acc_adtype: [
                    {required: true, message: '创意类型必选'}
                ],
                adslot_acc_adtypeArr: [
                    {required: true, message: '创意类型必选'}
                ],
                creative_type_id: [
                    {required: true, message: '创意样式必选'}
                ],
                video_sound: [
                    {
                        required: true,
                        validator(rule, value, callback) {
                            callback();
                        },
                        message: '视频声音必选'
                    }
                ],
                video_auto_play: [
                    {
                        required: true,
                        validator(rule, value, callback) {
                            callback();
                        },
                        message: '视频自动播放必选'
                    }
                ],
                shake_num_switch: [
                    {required: true, message: '交互样式摇一摇必选'}
                ],
                bidding_type: [
                    {required: true, message: '竞价类型必选'}
                ],
                bid_cpm: [
                    {required: true, message: 'CPM价格必填'},
                    {
                        validator(rule, value, callback) {
                            const reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
                            if (reg.test(value) && Number(value) > 0) {
                                callback();
                            } else {
                                callback(new Error("请输入有效数字"));
                            }
                        },
                        message: '仅支持2位小数'
                    },
                ]
            },
            form: {
                media_id: '',
                render_method: RenderMethod[0].value,
                acc_adtype: AccAdtypes[0].value,
                bidding_type: BiddingTypes[0].value,
                video_sound: VideoSound[0].value,
                shake_num_switch: 1,
                shake_num: '',
                video_auto_play: '',
                adslot_acc_adtypeArr: []
            },
            platform: '', // 选择媒体后读取该媒体应用类型(android、iOS、鸿蒙)
        }
    },
    
    computed: {
        id() {
            return this.$route.query.id || ''
        },
        appName() {
            return this.$route.query.appName || ''
        },
        is_acc_adtype() {
            return this.form.render_method === RenderEnum.TEMPLATE || false
        },
        is_video() {
            return (this.form.acc_adtype && this.form.acc_adtype !== 2) || this.form.adslot_acc_adtypeArr.includes('4') || this.form.adslot_acc_adtypeArr.includes('11')
        }
    },
    
    async created() {
        this.userInfo = this.$ls.get('userInfo');
        this.biddingTypeOptions = this.userInfo.auth.server_bid_auth ? BiddingTypes2 : BiddingTypes;
        
        await this.getAllAppList();
        await this.getStyleList();
        
        if (this.id) {
            await this.getDetail()
        }
    },
    
    methods: {
        async getDetail() {
            const {data = {}} = await getCodeDetail({
                id: this.id
            })
            this.form = {
                ...this.form,
                ...data,
                adslot_acc_adtypeArr: (data.adslot_acc_adtype || '').split(',')
            }
            
            // 选择应用读取对应平台
            if (this.form.media_id) {
                const item = this.appOptions.find(v => v.id === this.form.media_id);
                switch (item.type) {
                    case 1:
                        this.platform = 'android';
                        break;
                    case 3:
                        this.platform = 'ios';
                        break;
                    case 5:
                        this.platform = 'HarmonyOS';
                        break;
                }
            }
            
            if (!data.shake_num) {
                this.form.shake_num_switch = 2;
            }
            
            this.getStyleList()
        },
        
        async getAllAppList() {
            const {data = []} = await getAllAppList({ status: 0 })
            this.appOptions = data
            if (!this.id && !this.form.media_id && data.length === 1) {
                this.form.media_id = data[0].id
            }
            data.forEach(item => {
                this.appOptionsMap[item.id] = item.name
                if (!this.id && item.name === this.appName) {
                    this.form.media_id = item.id
                }
            })
            if (this.form.media_id) {
                this.getStyleList()
            }
        },
        
        async getStyleList() {
            const {data = []} = await getStyleList({
                media_id: this.form.media_id,
                acc_adtype: this.form.acc_adtype,
                adslot_type: this.codeType
            });
            this.styleOptions = data;
            
            // 选择应用读取对应平台
            if (this.form.media_id) {
                const item = this.appOptions.find(v => v.id === this.form.media_id);
                switch (item.type) {
                    case 1:
                        this.platform = 'android';
                        break;
                    case 3:
                        this.platform = 'ios';
                        break;
                    case 5:
                        this.platform = 'HarmonyOS';
                        break;
                }
            }
        },
        
        handleRenderMethodChange() {
            this.$delete(this.form, 'creative_type_id')
            this.$delete(this.form, 'acc_adtype')
            this.$set(this.form, 'adslot_acc_adtypeArr', [])
        },
        
        handleAccAdtypeChange() {
            this.$delete(this.form, 'creative_type_id')
            this.getStyleList()
        },
        
        handleBiddingTypeChange() {
            this.$delete(this.form, 'bid_cpm')
        },
        
        onCancel() {
            this.$router.go(-1);
        },
        
        async onSubmit() {
            if (this.form.adslot_acc_adtypeArr && this.form.adslot_acc_adtypeArr.length > 0) {
                let adslot_acc_adtype = [...this.form.adslot_acc_adtypeArr]
                this.form.adslot_acc_adtype = adslot_acc_adtype.join(',')
            }
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    if (this.platform === 'android' && this.form.shake_num_switch === 1 && !this.form.shake_num) {
                        this.$message.error('交互样式摇一摇必选');
                        return;
                    }
                    
                    // 所属应用 = iOS时, 固定交互样式摇一摇样式号
                    if (this.platform === 'ios') {
                        if (this.form.render_method === 1) {
                            // 模版渲染
                            this.form.shake_num = '127932';
                        } else {
                            // 自渲染
                            this.form.shake_num = '127935';
                        }
                    }
                    
                    // 所属应用 = 鸿蒙  或  交互样式摇一摇 = 关闭, 清除样式号
                    if (['HarmonyOS'].includes(this.platform) || this.form.shake_num_switch === 2) {
                        delete this.form.shake_num_switch;
                        delete this.form.shake_num;
                    }
                    
                    if (this.id) {
                        const {message = '编辑成功'} = await doEditCode({
                            ...this.form,
                            id: this.id,
                            type: this.codeType
                        })
                        this.$message.success(message)
                    } else {
                        const {message = '创建成功'} = await doAddCode({
                            ...this.form,
                            type: this.codeType
                        })
                        this.$message.success(message)
                    }
                    this.$router.go(-1);
                } else {
                    return false;
                }
            });
        }
    }
}
</script>
<style lang="scss">
.yyy_tips_wrap{
  padding: 0px 0 15px 130px;
  & .yyy_tips{
      line-height: 20px;
      font-size: 12px;
      color: #666;
      & .f_red{color: #f00;}
  }
}
</style>